import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MoonOutlinedSvg from "@ant-design/icons-svg/es/asn/MoonOutlined";
import AntdIcon from "../components/AntdIcon";
var MoonOutlined = function MoonOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MoonOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MoonOutlined.displayName = 'MoonOutlined';
}
export default /*#__PURE__*/React.forwardRef(MoonOutlined);